/** Build tel: href from a display phone string (shared by marketing + documents). */
export function phoneTelHref(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  return digits ? `tel:+${digits.replace(/^\+/, '')}` : '';
}
